import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { Form } from "../../interfaces/forms";
import strings from "../../utils/strings.json";

interface TextFormProps {
  field: Form;
}

function TextForm(props: TextFormProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={props.field.name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          dir="rtl"
          sx={{
            width: "100%",
            direction: "rtl",
            "& .MuiInputBase-input-MuiOutlinedInput-input": {
              color: "red",
              direction: "rtl",
            },
            "& .MuiOutlinedInput-input": {
              direction: "ltr",
            },
          }}
          label={props.field.label}
          placeholder={props.field.placeholder ? props.field.placeholder : ""}
          error={!!errors[props.field.name]}     
          helperText={
            errors[props.field.name]
              ? `${props.field.placeholder as string}-${
                  strings.form.required
                }`
              : ""
          }
        />
      )}
    />
  );
}

export default TextForm;
